import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import Button from '../Button'

import localization from './localization'

import styles from './ContactForm.module.styl'

class ContactForm extends Component {
  static propTypes = {
    language: PropTypes.string.isRequired,
  }

  state = {
    errorMessage: null,
    loading: false,
    successMessage: null,
    touched: false,
    formData: {
      name: '',
      email: '',
      message: '',
    },
  }

  _handleChange = (e) => {
    const {
      target: { name, value },
    } = e
    this.setState({ formData: { ...this.state.formData, [name]: value } })
  }

  _handleSubmit = (e) => {
    e.preventDefault()

    this.setState({
      errorMessage: null,
      successMessage: null,
    })

    const { formData } = this.state
    const { language } = this.props

    const { ongewenst, ongewenstalt } = e.target.elements

    if (!ongewenst.value && !ongewenstalt.value && e.target.checkValidity()) {
      axios
        .post(
          `https://staticmailer.pexel.nl/${localization[language].form.id}`,
          formData
        )
        .then(() => {
          this.setState({
            successMessage: localization[language].feedback.success,
            touched: false,
            formData: {
              ...this.state.formData,
              name: '',
              email: '',
              message: '',
            },
          })
        })
        .catch(() => {
          this.setState({
            errorMessage: localization[language].feedback.genericError,
          })
        })
    }

    return null
  }

  render() {
    const {
      errorMessage,
      successMessage,
      touched,
      formData: { name, email, message },
    } = this.state

    const { language } = this.props

    return (
      <React.Fragment>
        {errorMessage && (
          <div className={styles.feedbackError}>{errorMessage}</div>
        )}
        {successMessage && (
          <div className={styles.feedbackSuccess}>{successMessage}</div>
        )}

        <form
          onSubmit={(e) => {
            this._handleSubmit(e)
          }}
          className={touched ? 'touched' : null}
        >
          <label className="ongewenst">
            Dit veld leeglaten / Leave this field empty / Dieses Feld leer
            lassen
            <input type="text" name="ongewenst" tabIndex="-1" />
          </label>
          <input type="hidden" name="ongewenstalt" />

          <label>
            {localization[language].form.labelName}
            <input
              type="text"
              name="name"
              value={name}
              onChange={this._handleChange}
              required
            />
          </label>

          <label>
            {localization[language].form.labelEmail}
            <input
              type="email"
              name="email"
              value={email}
              onChange={this._handleChange}
              required
            />
          </label>

          <label>
            {localization[language].form.labelMessage}
            <textarea
              name="message"
              value={message}
              onChange={this._handleChange}
              required
            />
          </label>

          <br />

          <Button
            loading={this.state.loading}
            size="large"
            type="submit"
            onClick={() => {
              this.setState({ touched: true })
            }}
          >
            {localization[language].form.submit} »
          </Button>
        </form>
      </React.Fragment>
    )
  }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js